export const SETUP_CATEGORIES = [
  { id: 'all', label: 'Tümü' },
  { id: 'smart-tv', label: 'Smart TV' },
  { id: 'android', label: 'Android' },
  { id: 'ios', label: 'iPhone / macOS' },
  { id: 'satellite', label: 'Uydu Alıcı' },
  { id: 'tools', label: 'Server / M3U' },
];

export const SETUP_APPS = [
  {
    id: 'smart-iptv',
    category: 'smart-tv',
    name: 'Smart IPTV',
    description: 'Samsung ve LG Smart TV’ler için IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/smartiptv.webp',
    actionLabel: 'Uygulamanın sitesine git',
    actionUrl: 'https://siptv.app/mylist/',
    hasM3u: true,
    steps: [
      'TV’nizin uygulama mağazasından Smart IPTV’yi yükleyip açın.',
      'Ekrandaki MAC/ID bilgisini not alın.',
      'Smart IPTV liste sayfasını açın.',
      'MAC/ID bilgisini ve M3U bağlantınızı ilgili alanlara girin.',
      '“Send” düğmesine tıklayın.',
      'Uygulamayı yeniden başlatın.',
    ],
    note: 'Aktivasyon cihaz başına tek seferlik 5,49 €’dur.',
  },
  {
    id: 'ss-iptv',
    category: 'smart-tv',
    name: 'SS IPTV',
    description: 'LG ve desteklenen Samsung Smart TV’ler için IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/ssiptv.png',
    actionLabel: 'Liste sayfasını aç',
    actionUrl: 'https://ss-iptv.com/en/users/playlist',
    hasM3u: true,
    steps: [
      'LG TV’nizde SS IPTV’yi LG Content Store’dan yükleyin.',
      'Samsung TV’de resmî USB kurulumunu uygulayın: ss-iptv.com/en/users/documents/installing.',
      '“Settings” > “General” > “Get Code” yolundan bağlantı kodunu alın.',
      'SS IPTV liste sayfasında cihazınızı ekleyin.',
      '“External Playlists” bölümünden M3U bağlantınızı kaydedin.',
      'TV’deki uygulamayı yenileyin.',
    ],
  },
  {
    id: 'asx-iptv',
    category: 'smart-tv',
    name: 'ASX IPTV',
    description: 'Smart TV’ler için M3U destekli IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/asx.png',
    actionLabel: 'Playlist sayfasını aç',
    actionUrl: 'https://asxiptv.net/playist_editor',
    hasM3u: true,
    steps: [
      'TV’nizin uygulama mağazasından ASX IPTV’yi yükleyip açın.',
      'Ekrandaki MAC adresini not alın.',
      'ASX IPTV liste sayfasını açın.',
      'MAC adresinizi ve M3U bağlantınızı girin.',
      '“Playlist Upload” düğmesine tıklayın.',
      'Uygulamayı yeniden başlatın.',
    ],
  },
  {
    id: 'smartone',
    category: 'smart-tv',
    name: 'SmartOne',
    description: 'Smart TV platformları için IPTV oynatıcı',
    setupType: 'M3U ile kurulum',
    logo: '/kurulum-icon/smartone.png',
    actionLabel: 'SmartOne sitesine git',
    actionUrl: 'https://www.smartone-iptv.com/plugin/smart_one/main_generate',
    hasM3u: true,
    steps: [
      'TV’nizin uygulama mağazasından SmartOne’ı yükleyip açın.',
      'Ekrandaki MAC adresini not alın.',
      'SmartOne liste sayfasını açın.',
      '“Xtream Playlist” sekmesini açın.',
      'MAC adresini, liste adını ve M3U bağlantısını girin.',
      '“Add Playlist” düğmesine tıklayıp uygulamayı yeniden başlatın.',
    ],
    note: 'Lisans cihaz başına 12,99 € kalıcı veya yıllık 2,50 €’dur.',
  },
  {
    id: 'televizo',
    category: 'android',
    name: 'Televizo',
    description: 'Android telefon, tablet ve TV için IPTV oynatıcı',
    setupType: 'Xtream Codes',
    logo: '/kurulum-icon/televizo.png',
    steps: [
      'Televizo’yu Google Play Store’dan yükleyip açın.',
      '“Yeni liste oluştur” seçeneğine tıklayın.',
      '“Yeni Xtream Codes liste” seçeneğini seçin.',
      'Profil adı, sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      'Sağ üstteki onay işaretine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
  },
  {
    id: 'vu-iptv',
    category: 'ios',
    name: 'VU IPTV Player',
    description: 'iPhone ve iPad için IPTV oynatıcı',
    setupType: 'Xtream Codes',
    logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/23/31/0c/23310cfd-e04f-bf07-d172-74c957918f8b/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/512x512bb.jpg',
    actionLabel: 'App Store’dan İndir',
    actionUrl: 'https://apps.apple.com/tr/app/vu-iptv-player/id6526480705',
    steps: [
      'iPhone’unuzda “App Store’dan İndir” düğmesiyle Byte9 Inc tarafından yayımlanan VU IPTV Player’ı yükleyin.',
      'Uygulamayı açıp yeni hesap veya oynatma listesi ekleme bölümüne girin.',
      '“Xtream Codes” giriş yöntemini seçin.',
      'Liste adı istenirse “Tivigo” yazın.',
      'Bu sayfadaki sunucu adresini, kullanıcı adınızı ve şifrenizi kopyalayıp ilgili alanlara yapıştırın.',
      'Bilgileri kaydedip kanal, film ve dizi listesinin yüklenmesini bekleyin.',
      'Bilgi: iOS 16 veya üzeri gerekir.',
    ],
  },
  {
    id: 'uhf',
    category: 'ios',
    name: 'UHF',
    description: 'macOS için IPTV oynatıcı',
    setupType: 'Xtream Codes',
    logo: 'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/1f/e4/0b/1fe40b42-84a3-b793-dc77-a2df074f0268/uhf-ios-icon-0-0-1x_U007epad-0-1-0-85-220.png/512x512bb.jpg',
    actionLabel: 'App Store’dan İndir',
    actionUrl: 'https://apps.apple.com/tr/app/uhf-love-your-iptv/id6443751726?platform=mac',
    steps: [
      'Mac’inizde “App Store’dan İndir” düğmesiyle UHF - Love your IPTV uygulamasını yükleyin.',
      'Uygulamayı açıp yeni oynatma listesi ekleme bölümüne girin.',
      '“Xtream” liste türünü seçin.',
      'Liste adı istenirse “Tivigo” yazın.',
      'Bu sayfadaki sunucu adresini, kullanıcı adınızı ve şifrenizi kopyalayıp ilgili alanlara yapıştırın.',
      'Bilgileri kaydedip kanal, film ve dizi listesinin yüklenmesini bekleyin.',
      'Bilgi: Apple M1 veya üzeri işlemcili Mac ve macOS 13 veya üzeri gerekir.',
    ],
  },
  {
    id: 'smarters-lite-ios',
    category: 'ios',
    name: 'Smarters Player Lite',
    description: 'iPhone, iPad ve Apple TV için medya oynatıcı',
    setupType: 'Xtream Codes',
    logo: '/kurulum-icon/smarters_lite.webp',
    actionLabel: 'App Store’dan indir',
    actionUrl: 'https://apps.apple.com/tr/app/smarters-player-lite/id1628995509?l=tr',
    steps: [
      'Smarters Player Lite’ı App Store’dan yükleyip açın.',
      '“Add New User” seçeneğine tıklayın.',
      '“Login with Xtream Codes API” seçeneğini seçin.',
      'Liste adı, sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      '“Add User” düğmesine tıklayın.',
      'Oluşturulan profili seçin.',
    ],
  },
  {
    id: 'cloud-stream',
    category: 'ios',
    name: 'Cloud Stream IPTV',
    description: 'iPhone, iPad ve Apple TV için M3U oynatıcı',
    setupType: 'M3U bağlantısı',
    logo: '/kurulum-icon/cloudstream.webp',
    actionLabel: 'App Store’dan indir',
    actionUrl: 'https://apps.apple.com/tr/app/cloud-stream-iptv-player/id1138002135?l=tr',
    hasM3u: true,
    steps: [
      'Cloud Stream IPTV Player’ı App Store’dan yükleyip açın.',
      'Yeni oynatma listesi ekleme seçeneğini açın.',
      'M3U bağlantınızı URL alanına yapıştırın.',
      'Listeyi kaydedip açın.',
    ],
  },
  {
    id: 'iptvx-ios',
    category: 'ios',
    name: 'IPTVX',
    description: 'iPhone, iPad ve Apple TV için IPTV oynatıcı',
    setupType: 'Xtream API',
    logo: '/kurulum-icon/iptvx.jpg',
    actionLabel: 'App Store’dan indir',
    actionUrl: 'https://apps.apple.com/tr/app/iptvx/id1451470024?l=tr',
    steps: [
      'IPTVX’i App Store’dan yükleyip açın.',
      '“Add Playlist” seçeneğine tıklayın.',
      '“Xtream API” seçeneğini seçin.',
      'Liste adı, sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      'Bilgileri kaydedip oluşturulan listeyi açın.',
    ],
  },
  {
    id: 'xtream-plugin',
    category: 'satellite',
    name: 'Xtream Codes Plugin',
    description: 'Xtream Codes destekli uydu alıcıları',
    setupType: 'Cihaza göre Xtream Codes',
    logo: '/kurulum-icon/xtream%20logo.jpg',
    steps: [
      'Cihaz modelinizin Xtream Codes desteğini kullanım kılavuzundan doğrulayın.',
      'Uyumlu IPTV eklentisini üreticinin resmî kaynağından yükleyin.',
      'Eklentide yeni hesap ekleme seçeneğini açın.',
      'Sunucu URL’si, kullanıcı adı ve şifre bilgilerini girin.',
      'Bilgileri kaydedip hesabı açın.',
    ],
  },
  {
    id: 'nextstar',
    category: 'satellite',
    name: 'NextStar IPTV',
    description: 'M3U destekli NextStar uydu alıcıları',
    setupType: 'Cihaza göre M3U',
    logo: '/kurulum-icon/nextstar.png',
    hasM3u: true,
    steps: [
      'Cihaz modelinizin M3U desteğini kullanım kılavuzundan doğrulayın.',
      'Cihazın “IPTV” veya “Web TV” bölümünü açın.',
      '“Yeni Liste” veya “M3U URL” seçeneğini seçin.',
      'M3U bağlantınızı ilgili alana yapıştırıp kaydedin.',
    ],
  },
  {
    id: 'server-info',
    category: 'tools',
    name: 'Sunucu Bilgilerim',
    description: 'Sunucu URL’si, port, kullanıcı adı ve şifre',
    setupType: 'Bağlantı aracı',
    logo: '/kurulum-icon/sunucu.png',
    kind: 'credentials',
    steps: [
      'Uygulamada “Xtream Codes” veya “Portal Login” seçeneğini açın.',
      'Sunucu URL’si, port, kullanıcı adı ve şifre bilgilerini ilgili alanlara girin.',
      'Bilgileri kaydedip profilinizi açın.',
    ],
  },
  {
    id: 'm3u',
    category: 'tools',
    name: 'M3U Oluştur',
    description: 'Uygulamaya özel M3U bağlantısı',
    setupType: 'Bağlantı aracı',
    logo: '/kurulum-icon/m3u.png',
    kind: 'm3u',
    hasM3u: true,
    steps: [
      'Uygulamanızın M3U veya Playlist URL desteğini doğrulayın.',
      'İçerik ve logo seçeneğini belirleyin.',
      'M3U bağlantınızı oluşturun.',
      'Bağlantıyı uygulamadaki Playlist URL alanına yapıştırıp kaydedin.',
    ],
  },
];

export const OFFICIAL_SETUP_GUIDES = {
  android: {
    steps: [
      'Tivigo’yu Google Play Store’dan yükleyip açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
  },
  windows: {
    steps: [
      'Tivigo Windows uygulamasını indirin.',
      'İndirilen .exe dosyasını çalıştırıp kurulumu tamamlayın.',
      'Uygulamayı açıp kullanıcı adınız ve şifrenizle giriş yapın.',
    ],
  },
  ios: {
    steps: [
      'Tivigo’yu App Store’dan yükleyip açın.',
      'Kullanıcı adınızı ve şifrenizi girin.',
      '“Giriş Yap” düğmesine tıklayın.',
      'Kanal listeniz otomatik yüklenir.',
    ],
  },
  lg: {
    steps: [
      'LG Content Store’u açın.',
      'Arama alanına “Tivigo” yazın.',
      'Tivigo uygulamasını yükleyip açın.',
      'Kullanıcı adınız ve şifrenizle giriş yapın.',
    ],
  },
  macos: {
    steps: [
      'Tivigo macOS kurulum dosyasını indirin.',
      'İndirilen .dmg dosyasını açın.',
      'Tivigo uygulamasını Applications klasörüne sürükleyin.',
      'Güvenlik uyarısı görüntülenirse “Sistem Ayarları > Gizlilik ve Güvenlik > Yine de Aç” yolunu izleyin.',
      'Uygulamayı açıp kullanıcı adınız ve şifrenizle giriş yapın.',
    ],
  },
};
